import { Checkbox, styled, MenuItem as MuiMenuItem, Switch, Box, Button, FormControl, TextField, TableCell, TableRow, TableSortLabel, tableCellClasses } from "@mui/material";
import { default as emotionStyled } from "@emotion/styled";

export const MainWrapper = styled('div')({
    padding: "38px 10px",
    minHeight: "calc(100vh - 80px)",
    position: "relative",
    overflow: 'hidden'
});

export const IntroSection = styled('div')({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

export const styles = {
    onboardingCards: {
        m: "auto",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: "58px",
        justifyContent: "center",
        gap: 2,
    },
    onboardingCardLink: {
        textDecoration: "none"
    },
    onboardingCard: {
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.04)",
        width: "156px",
        height: "155px",
        padding: "19px 11px",
        borderRadius: "4px"
    },
    onboardingCardImageBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    } as React.CSSProperties,
    onboardingCardImage: {
        width: "50px",
        height: "50px"
    },
    onboardingCardContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    } as React.CSSProperties,
    onboardingCardTitle: {
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "20px",
        textAlign: "center",
        color: "#11192A",
        margin: "9px 0 0 0",
        marginTop: "9px"
    } as React.CSSProperties,
    onboardingCardDesc: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "10px",
        lineHeight: "14px",
        textAlign: "center",
        color: "rgba(17, 25, 42, 0.69)",
        marginTop: "5px"
    } as React.CSSProperties,
};

export const OnboardingFormWrapper = styled('div')({
    margin: "30px auto 0 auto",
})

export const OnboardingFormGrid = styled('div')({
    background: "white",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "18px",
    borderRadius: "8px"
})

export const GridElementFullWidth = styled('div')({ width: "100%", gridColumn: "1/-1" })
export const GridElement = styled('div')({ width: "100%" })
export const buttonSelectionWrapperStyle = {
    display: "flex",
    gap: "7px",
}
export const requestsTableStyles = { width: "100%",  boxShadow: "0px 4px 4px rgba(17, 25, 42, 0.04)", borderRadius: "8px", margin: "30px auto 0 auto", background: "white", zIndex: 100, position: "relative" } as React.CSSProperties;
export const ServicesWrapper = styled('div')({
    display: "flex",
    alignItems: "center"
});
export const ServicesWrapperTitle = styled('div')({
    fontWeight: 600,
    fontSize: "12px",
    color: "#11192A",
    marginRight: "16px",
});

// RequestsFilter styled components
export const FilterContainer = styled(Box)({
    background: 'white',
    padding: '16px',
    borderRadius: '8px 8px 0 0',
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    alignItems: 'flex-end'
});

export const FilterFormControl = styled(FormControl)({
    minWidth: 150
});

export const FilterTextField = styled(TextField)({
    minWidth: 150
});

export const FilterButton = styled(Button)({
    height: 40
});

export const FilterButtonOutlined = styled(Button)({
    height: 40
});

// RequestsPagination styled components
export const PaginationContainer = styled(Box)({
    background: 'white',
    padding: '16px',
    borderRadius: '0 0 8px 8px',
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #ddd'
});

// RequestsTable styled components
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': {
        background: "#bed2f5 !important"
    },
    cursor: "pointer"
}));

export const StyledTableSortLabel = styled(TableSortLabel)({
    color: 'white !important',
    '& .MuiTableSortLabel-icon': {
        color: 'white !important'
    },
    '&:hover': {
        color: 'white !important'
    },
    '&.Mui-active': {
        color: 'white !important'
    }
});

export const MUICheckbox = styled(Checkbox)({
    padding: 0
});

export const CheckboxLabel = styled("div")({
    marginLeft: "5px",
    display: "flex",
    alignItems: "center",
});

export const AddUserTitle = styled("div")({
    fontWeight: "600",
    fontSize: "12px",
    color: "rgba(17, 25, 42, 0.7)",
    lineHeight: "16px",
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    "& span": {
        marginRight: "4px"
    }
});

export const ServicesCheckBoxList = styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",
    listStyle: "none",
    paddingInlineStart: "0px",
    marginBlockStart: "0",
    marginBlockEnd: "0",
})

export const ServicesCheckBoxListItem = styled("div")({
    position: "relative",
    borderRadius: "6px",
    background: "#EEF1F6",
    padding: "12px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "15px",
})

export const RemoveButton = styled("div")({
    cursor: "pointer",
    padding: "6px",
    background: "#E50A0A",
    position: "absolute",
    outline: "none",
    border: "none",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    right: "20px",
    top: "-10px",
    display: "flex",
    justifyItems: "center",
    alignItems: "center",
});

export const TextFieldWrapper = styled("div")({
    display: "grid",
});

export const ORContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    gap: "4px",
});

export const ORContainerLine = styled("span")({
    width: "100%",
    height: "1px",
    background: "#9B9999",
});

export const ORContainerText = styled("span")({
    color: "#9B9999",
    fontSize: "10px",
});

export const ButtonWrapper = styled("span")({
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "14px",
    gap: "12px",
});

export const FileInputWrapper = styled("div")({
    border: "1px dashed #11192A",
    padding: "23px",
    background: "#F9F8F8",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

export const FileInputUploadIconWrapper = styled("div")({
    position: "absolute",
    top: "-14px",
    width: "28px",
    height: "28px",
    background: "black",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const FileInput = styled("input")({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
});

export const FileInputTitle = styled("div")({
    color: "#11192A",
    fontSize: "14px",
    fontWeight: "600",
});

export const FileInputDesc = styled("div")({
    color: "#11192A",
    fontSize: "12px"
});

export const ClearForm = styled("button")({
    background: "none",
    outline: "none",
    textDecoration: "underline",
    border: "none",
    color: "#1B59DD",
    zIndex: "10",
    cursor: "pointer"
});

export const ContentContainer = styled('div')({
    margin: "30px auto 0 auto",
    width: "90%",
});

export const RequestDetailsMain = styled('div')({
    maxWidth: "1200px",
    margin: "0 auto",
});

export const RequestDetailsHeader = styled('div')({
    display: "flex",
});

export const RequestDetailsHeaderRight = styled('div')(() => `
    margin-left: auto;
    font-size: 14px;

    & span {
        font-weight: 600;
    }

    & a {
        color: #EB0A1E;
        font-weight: 600;
    }
`);


export const RequestDetailsHeaderMainContent = styled('div')({
    fontSize: "18px",
    fontWeight: "700",
    color: "#11192A",
    "& span": {
        color: "#609CFF"
    }
});

export const RequestDetailsHeaderLink = styled('a')({
    fontSize: "18px",
    fontWeight: "700",
    color: "#609CFF"
});

export const RequestDetailsLink = styled('a')({
    fontSize: "12px",
    fontWeight: "700",
    color: "#609CFF"
});

export const RequestDetailsHeaderSecondary = styled('div')({
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19px",
    color: "#11192A"
});

export const RequestDetailsContent = styled('div')({
    marginTop: "14px",
    display: "flex", 
    gap: "41px",
    zIndex: 10,
    position: "relative"
});

export const RequestDetailsContentBox = styled('div')({
    background: "white",
    flex: "0.6", 
    padding: "18px",
    boxShadow: "0px 4px 4px rgba(17, 25, 42, 0.04)",
    borderRadius: "8px",
    height: "65vh",
    maxHeight: "1000px",
    overflowY: "auto"
});

export const RequestDetailsStatusBox = styled('div')({
    background: "white",
    flex: "0.5", 
    padding: "18px",
    boxShadow: "0px 4px 4px rgba(17, 25, 42, 0.04)",
    borderRadius: "8px",
    height: "65vh",
    maxHeight: "1000px",
    overflowY: "auto"
});

export const RequestDetailsContentList = styled('div')({
    display: "flex",
    flexDirection: "column",
    gap: "11px",
});

export const RequestDetailsContentListItem = styled('div')({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "2px",
});

export const RequestDetailsLabel = styled('div')({
    flexShrink: "0",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "19px",
});

export const RequestDetailsValue = emotionStyled('div')((props: { isWhiteSpacePreline?: boolean }) => ({
    width: "100%",
    fontSize: "14px",
    color: "#888888",
    lineHeight: "19px",
    whiteSpace: props.isWhiteSpacePreline ? 'pre-line' : "unset",
}));

export const RequestDetailsContentBoxTitle = styled('h3')({
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "24px",
    color: "#11192A",
    margin: "0 0 23px 0",
    display: "flex",
    alignItems: "center"
});

export const RequestStatusWrapper = styled('div')({
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});

export const RequestStatusItem = styled('div')({
    display: "grid",
    gridTemplateColumns: "50px 1fr",
    gridTemplateRows: "minmax(70px, 1fr)"
});

export const RequestStatusItemLeft = styled('div')({
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr",
    gridGap: "8px"
});

export const RequestStatusItemRight = styled('div')({
    padding: "5px",
    overflow: "hidden",
    wordWrap: "break-word",
    wordBreak: "break-word",
    minWidth: 0
});

export const RequestStatusTitle = styled('div')({
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between"
});

export const RequestItemDesc = styled('div')({
    fontSize: "12px"
});

export const RequestTableTitle = styled('div')({
    fontSize: "10px",
    fontWeight: "500",
    marginBottom: "5px"
});

export const RequestTable = styled('div')({
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse",
});

export const RequestTableEmailCol = styled('th')({
    fontSize: "10px",
    textAlign: "left",
    width: "50%",
    border: "1px solid white",
    borderCollapse: "collapse",
    wordWrap: "break-word",
    backgroundColor: "rgb(17, 25, 42)",
    color: "white",
    padding: "3px",
    fontWeight: "500"
});

export const RequestTableRoleCol = styled('th')({
    fontSize: "10px",
    textAlign: "left",
    width: "30%",
    border: "1px solid white",
    borderCollapse: "collapse",
    backgroundColor: "rgb(17, 25, 42)",
    color: "white",
    padding: "3px",
    fontWeight: "500"
});

export const RequestTableStatusCol = styled('th')({
    fontSize: "10px",
    textAlign: "left",
    width: "20%",
    border: "1px solid white",
    borderCollapse: "collapse",
    backgroundColor: "rgb(17, 25, 42)",
    color: "white",
    padding: "3px",
    fontWeight: "500"
});

export const RequestTableEmailColTd = styled('td')({
    fontSize: "10px",
    textAlign: "left",
    widtd: "50%",
    wordWrap: "break-word",
    border: "1px solid white",
    borderCollapse: "collapse",
    padding: "3px",
    background: "#f2f5f9"
});

export const RequestTableRoleColTd = styled('td')({
    fontSize: "10px",
    textAlign: "left",
    width: "30%",
    border: "1px solid white",
    borderCollapse: "collapse",
    padding: "3px",
    background: "#f2f5f9"
});

export const RequestTableStatusColTd = styled('td')({
    fontSize: "10px",
    textAlign: "left",
    width: "20%",
    border: "1px solid white",
    borderCollapse: "collapse",
    padding: "3px",
    background: "#f2f5f9"
});

const requestNodeBaseStyle = {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
}

export const RequestStatusSuccess = styled('div')({
    background: "#6CDB6C",
    ...requestNodeBaseStyle
});

export const RequestStatusPending = styled('div')({
    position: "relative",
    "&::before": {
        content: "''",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        background: "trasparent",
        borderRadius: "50%",
        border: "3px solid #609CFF",
        borderTop: "3px solid white",
        animation: "spin 1.2s linear infinite"
    },
    "&::after": {
        content: "''",
        position: "absolute",
        width: "24px",
        height: "24px",
        background: "#609CFF",
        borderRadius: "50%",
        zIndex: "1",
    },
    "& img": {
        zIndex: "2",
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        },
    },
    ...requestNodeBaseStyle
});

export const RequestStatusDefault = styled('div')({
    background: "grey",
    ...requestNodeBaseStyle
});

export const RequestStatusError = styled('div')({
    background: "#eb4034",
    ...requestNodeBaseStyle
});

export const RequestStatusConnector = styled('div')({
    width: "5px",
    height: "100%",
    background: "#757677",
    marginLeft: "13px",
});

export const RequestLoaderWrapper = styled('div')({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100px"
});

export const RefreshButton = styled('div')({
    display: "flex",
    alignItems: "center",
    fontSize: "12px"
});

export const InputGroupTitle = styled('div')({
    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "10px",
    padding: 0
});

export const InputLabel = styled('div')({
    fontSize: "12px",
    fontWeight: "600",
    color: "#11192A",
    lineHeight: "16px",
    margin: "8px 0"
});

export const StepInfo = styled('div')({
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#6B86C1"
});

export const StepTitle = styled('div')({
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "27px",
    color: "#11192A"
});

export const RequestStatusHeader = styled('div')({
    display: "flex",
    justifyContent: "space-between",
});

export const RefreshIconWrapper = styled('div')({
    cursor: "pointer"
});

export const FormMessage = styled('div')({
    fontWeight: "bold",
    fontSize: "12px",
    color: "#11192A",
})

export const AddMoreUserBtnWrapper = styled('div')({
    display: "flex",
    justifyContent: "center",
    marginTop: "15px"
})

export const AddMoreUserBtn = styled('button')({
    border: "none",
    outline: "none",
    background: "transparent",
    color: "#1b59dd",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline-block",
    margin: "0 auto"
})

export const StepperWrapper = styled('div')({
    display: "flex",
    gap: "22px",
    marginBottom: "16px"
})

export const StepperItem = styled('div')({
    width: "100%"
})

export const StepperLine = styled('div')({
   width: "100%",
   height: "6px",
   background: "#9E9E9E",
   borderRadius: "4px",
   "&.stepper-item-active": {
        background: "#052F46",
   }
})

export const StepperItemInfo = styled('div')({
    display: "flex",
    gap: "10px",
    marginTop: "5px",
    alignItems: "center"
})

export const StepperStepName = styled('div')({
    color: "#9E9E9E",
    fontSize: "12px",
    fontWeight: "bold",
    "&.stepper-item-active": {
        color: "#052F46",
    }
 })

 export const ETAWrapper = styled('div')({
    border: "2px solid black",
    color: "black",
    padding: "2px 4px",
    fontSize: "10px",
    borderRadius: "100px",
    placeSelf: "flex-end",
    flexShrink: 0
 })

  export const EnvStatusTracker = styled('div')({
   marginTop: '16px',
   marginLeft: '20px'
 })

  export const EnvStatus = styled('div')({
   display: 'flex', 
   alignItems: 'center', 
   marginBottom: '8px',
   padding: '8px',
   backgroundColor: '#f5f5f5',
   borderRadius: '4px'
 })

export const selectMenuProps = {
    PaperProps: {
        style: {
            maxHeight: 200,
            overflow: "auto",
        },
    },
};

export const StyledMenuItem = styled(MuiMenuItem)({
    minHeight: "auto",
    padding: "4px 16px",
    "&.MuiMenuItem-root": {
        minHeight: "20px",
    },
});

export const StyledMenuItemCheckbox = styled(Checkbox)({
    padding: "2px 4px 2px 0",
    "&.Mui-checked": {
        color: "primary.main",
    },
});

export const CustomSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#1565c0',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#1976d2',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#757575',
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#424242',
  },
  '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
    backgroundColor: '#1565c0',
  },
}));